/**
 * Created by Vladislav on 03.09.2026
 */

CupsConfig.TYPE_DAILY = "daily";

CupsConfig.TYPES[CupsConfig.TYPE_DAILY] = {
    available: cleverapps.config.availables.DAILY_CUP,
    scenes: [cleverapps.Environment.SCENE_MAIN, cleverapps.Environment.SCENE_DAILY_CUP],
    rewards: RewardsConfig.DailyCup,
    force: Forces.DAILY_CUP,
    duration: cleverapps.parseInterval("1 hour"),
    cooldown: 0,
    topLimit: 25,
    statsLimit: 25
};

if (["wordsoup", "scramble", "magicwords", "crocword"].indexOf(cleverapps.config.name) !== -1) {
    CupsConfig.TYPES[CupsConfig.TYPE_DAILY].duration = cleverapps.parseInterval("3 hours");
}

if (cleverapps.config.debugMode || typeof cc === "undefined" && process.env.NODE_ENV !== "production") {
    CupsConfig.TYPES[CupsConfig.TYPE_DAILY].duration = cleverapps.parseInterval("3 minutes");
}
